import { Routes } from "@angular/router";
import { SendListComponent } from "./send-list/send-list.component";
import { getPathComponent } from "@app/shared/functions";
import { RecoverComponent } from "./recover/recover.component";
import { ViewListHomeComponent } from "./view-list-home/view-list-home.component";

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'nova',
	},
	...getPathComponent(
		["nova", "criar", "nova-lista", "cadastrar"],
		SendListComponent,
	),
	...getPathComponent(
		["recuperar-lista", "recuperar"],
		RecoverComponent,
	),
	...getPathComponent(
		["ver", "ver-lista/:hash"],
		ViewListHomeComponent,
	),

];
